export default "__VITE_ASSET__DiCCbMoz__"